import * as types from "./types";

export const setSelectMode = (selectMode) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_SELECT_MODE,
      payload: { selectMode },
    });
  };
};

export const setSelectAll = (selectAll) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_SELECT_MODE,
      payload: { selectAll },
    });
  };
};

export const addCurrentSelectedItems = (items) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_CURRENT_SELECTED_ITEMS,
      payload: { items },
    });
  };
};

export const removeCurrentSelectedItems = (items) => {
  return (dispatch) => {
    dispatch({
      type: types.REMOVE_CURRENT_SELECTED_ITEMS,
      payload: { items },
    });
  };
};

export const resetCurrentSelectedItems = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_SELECTED_ITEMS,
      payload: {},
    });
  };
};
